module.exports = __webpack_public_path__ + "img/bos.18ae38db.svg";